import { CartItem } from '@/types';
import { calculateCartItemDiscount } from '@/lib/discount';
import { formatPrice } from '@/lib/utils';

interface DiscountSummaryProps {
  cart: CartItem[];
}

export function DiscountSummary({ cart }: DiscountSummaryProps) {
  const discountBreakdown = cart.map(item => {
    const { totalOriginalPrice, totalDiscountValue, totalFinalPrice, discountInfo } = calculateCartItemDiscount(item);
    return {
      item,
      totalOriginalPrice,
      totalDiscountValue,
      totalFinalPrice,
      discountInfo
    };
  }).filter(breakdown => breakdown.discountInfo.hasDiscount && breakdown.discountInfo.isEligible);

  if (discountBreakdown.length === 0) {
    return null;
  }

  const totalSavings = discountBreakdown.reduce((sum, breakdown) => sum + breakdown.totalDiscountValue, 0);

  return (
    <div className="bg-brand-50 rounded-lg p-4 border border-brand-200">
      <h3 className="text-sm font-bold text-brand-800 mb-3">
        🎉 Active Discounts
      </h3>
      <div className="space-y-2">
        {discountBreakdown.map((breakdown, index) => (
          <div key={index} className="flex justify-between items-center text-sm">
            <span className="text-brand-700 truncate mr-2">
              {breakdown.item.produt_name}
            </span>
            <span className="text-brand-700 font-medium">
              -{formatPrice(breakdown.totalDiscountValue)}
            </span>
          </div>
        ))}
        <div className="border-t border-brand-200 pt-2 mt-2">
          <div className="flex justify-between items-center text-sm font-bold">
            <span className="text-brand-900">Total Savings:</span>
            <span className="text-brand-900">
              -{formatPrice(totalSavings)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}